import Cookies from 'js-cookie'
import {isEmpty} from 'lodash'
import {useLocation} from 'react-router-dom'
import {useSelector} from './redux'

const defaultLimit = '100'
const limitKey = (pathname: string, userId: string) => `${pathname.replace(/\//g, '')}#${userId}__disp_emp_limit`

export const getSavedDisplayEmployeeLimit = (pathname: string, userId: string): string => {
  if (window.localStorage) {
    const limit = window.localStorage.getItem(limitKey(pathname, userId))
    if (!isEmpty(limit)) {
      return limit as string
    }
  }
  const limit = Cookies.get(limitKey(pathname, userId))
  return isEmpty(limit) ? defaultLimit : (limit as string)
}

export const saveDisplayEmployeeLimit = (pathname: string, userId: string, limit: string) => {
  if (window.localStorage) {
    window.localStorage.setItem(limitKey(pathname, userId), limit)
  } else {
    Cookies.set(limitKey(pathname, userId), limit)
  }
}

export const useDisplayEmployeeLimit = (): [string, (value: string) => void] => {
  const {pathname} = useLocation()
  const currentUser = useSelector((state) => state.session.currentUser)
  const limit = getSavedDisplayEmployeeLimit(pathname, currentUser.id)
  return [limit, (limit) => saveDisplayEmployeeLimit(pathname, currentUser.id, limit)]
}
